import { useEffect, useMemo, useState, } from "react";
import { useNavigate } from "react-router-dom";

import TableCustom from "../../../components/ui/TableCustom";
import createContentColumns from "./content/contentColumns";
import { ContentType } from "./content/dailyCheckInTypes";
import { fetchContentList } from "./services/dailyCheckIn.services";

const ContentTabContent = () => {
  const [displayData, setDisplayData] = useState<ContentType[] | any>([]);
  const navigate = useNavigate();

  const handleEditClick = (record: ContentType) => {
    navigate(`/zippy-and-me/daily-check-in/content/${record.checkinId}/detail`);
  };

  const getContentList = async () => {
    const data = await fetchContentList();

    if (data) setDisplayData(data.data);
  }

  const dateFilters = useMemo(() => {
    return [
      ...new Set(displayData.map((item: ContentType) => item.monthText)),
    ].map(month => ({
      text: month,
      value: month,
    }))
  }, [displayData])

  useEffect(() => {
    getContentList();
  }, []);

  return (
    <>
      <div className="table-container">
        <TableCustom
          rowKey={(record: ContentType) => record.checkinId}
          columns={createContentColumns(dateFilters,handleEditClick)}
          dataSource={displayData}
          pagination={false}
        />
      </div>
    </>
  );
};

export default ContentTabContent;
